import "./Body.scss"

export const Body = ({ children = null, className = "" }) => (
  <div
    className={`Body maax-font-weight-regular ${className}`}
    data-testid="Body"
  >
    {children}
  </div>
)

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// Body.propTypes = {
//   children: PropTypes.node,
//   className: PropTypes.string,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// Body.defaultProps = {
//   children: null,
//   className: "",
// }
